import axios from 'axios';

import {
  configureHttpHeaders,
  onSuccess,
  onError,
} from './apiHelpers';
import { getDimsCaseValidatorUrl } from './dimsCaseValidatorUrl.js';

const DIMS_CASE_VALIDATOR_API = getDimsCaseValidatorUrl();

export function deleteNonDimsCase(caseNumber) {
  configureHttpHeaders(axios);
  return deleteUrl(`api/v1/dims/delete/casedetails/${caseNumber}`);
}

function deleteUrl(endpoint) {
  return axios.delete(`${DIMS_CASE_VALIDATOR_API}${endpoint}`)
    .then(onSuccess)
    .catch(onError);
}
export default {
        deleteNonDimsCase
};